/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFRAME_URL } from "../config/consts";
import { Category, IGame, IGamesRequest, Provider } from "../interfaces/intefaces";
import {
    AllGamesIcon,
    BaccaratIcon,
    BlackjackIcon,
    FavoritesIcon,
    FeatureBuyIcon,
    LiveCasinoIcon,
    LobbyIcon,
    LottoIcon,
    MoreGamesIcon,
    NewGamesIcon,
    OthercasinoIcon,
    OtherGamesIcon,
    PokerIcon,
    RouletteIcon,
    ScratchCardsIcon,
    TableGamesIcon,
    TopPicksIcon,
    VideoSlotsIcon,
    VirtualGames,
} from "../components/Icons";
import { routes } from "../router/Routes";

declare const menu_links: Record<string, string>;

export const getExternalLink = (slug: string) => (slug in menu_links ? menu_links[slug] : "/");

export const getCookie = (name: string) => {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName.trim() === name) {
            return cookieValue;
        }
    }
    return null;
};

export const getGameUrl = (game: IGame) => {
    return `/game/?id=${game.id}&plid=${game.pu}`;
};

export const getGameIframe = (game: IGame, userIsLoggedIn: boolean, for_fun: boolean) => {
    if (userIsLoggedIn) {
        if (!for_fun) {
            const username = getCookie("animacore-username");
            const token = getCookie("animacore-" + game.pu);
            return `${game.url}&username=${username}&token=${token}`;
        } else {
            return `${game.url}`;
        }
    } else {
        return `${game.url}`;
    }
};

function getQueryParams(urlString: string) {
    const url = new URL(urlString);
    const searchParams = url.searchParams;

    // Create an empty object to store the query parameters
    const queryParams: any = {};

    // Loop through each query parameter and add it to the object
    searchParams.forEach((value, key) => {
        queryParams[key] = value;
    });

    return queryParams;
}

export const getGameIframeFromUrl = (search: string, userIsLoggedIn: boolean) => {
    const queryParams = getQueryParams(IFRAME_URL + search);
    const plat_user = queryParams.plat_user;
    const for_fun = queryParams.for_fun === "true";
    const gameId = queryParams.gameId;
    const pid = queryParams.pid;
    const ct = queryParams.ct;

    const url = IFRAME_URL + `?gameId=${gameId}&lang=en&pid=${pid}&ct=${ct}`;
    if (userIsLoggedIn) {
        if (!for_fun) {
            const username = getCookie("animacore-username");
            const token = getCookie("animacore-" + plat_user);
            return `${url}&username=${username}&token=${token}`;
        } else {
            return `${url}`;
        }
    } else {
        return `${url}`;
    }
};

export const createRequestJSON = (props: IGamesRequest) => {
    const JSONTemplate: any = {
        mobile: props.mobile,
        hot: props.hot,
        new: props.new,
    };
    const data = Object.assign({}, JSONTemplate);

    if (props.category_id > 0) {
        data.category_id = props.category_id;
    }
    data.categoryType = props.categoryType;

    if (props.prs.length) {
        data.prs = props.prs.join(",");
    }

    return data;
};

export const getOptionsForCategories = (
    categories: Category[],
    activeCategory: number,
    selected: boolean,
): Array<{ value: number; label: string; slug: string }> => {
    if (selected) {
        if (activeCategory) {
            const filtered = categories.filter(option => activeCategory == option.id);
            const options = filtered.map(option => ({
                value: option.id,
                label: option.name,
                slug: option.slug,
            }));
            return options;
        } else {
            return [];
        }
    } else {
        const options = categories.map(option => ({
            value: option.id,
            label: option.name,
            slug: option.slug,
        }));

        return options;
    }
};

export const getOptionsForProviders = (
    providers: Provider[],
    activeProvider: number[],
    selected: boolean,
): Array<{ value: number; label: string }> => {
    if (selected) {
        if (activeProvider.length) {
            const filtered = providers.filter(option => activeProvider.includes(option.id));
            const options = filtered.map(option => ({
                value: option.id,
                label: option.name,
            }));
            return options;
        } else {
            return [];
        }
    } else {
        const options = providers.map(option => ({
            value: option.id,
            label: option.name,
        }));

        return options;
    }
};

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional, smooth scrolling animation
    });
};

const IconList: any = {
    "video-slots": VideoSlotsIcon,
    "video-poker": PokerIcon,
    "video-bingo": LottoIcon,
    "scratch-cards": ScratchCardsIcon,
    "other-casino": OthercasinoIcon,
    "table-games": TableGamesIcon,
    "feature-buy": FeatureBuyIcon,
    Other: OtherGamesIcon,
    roulette: RouletteIcon,
    blackjack: BlackjackIcon,
    Baccarat: BaccaratIcon,
    "virtual-sports": VirtualGames,
    livecasino: LiveCasinoIcon,
    default: VideoSlotsIcon,
    "more-games": MoreGamesIcon,
};

export const getCategoryIcon: any = (icon: string) => {
    return icon in IconList ? IconList[icon] : IconList["default"];
};

export const isExternalPage = (route: string): boolean => {
    return !(
        location.pathname === routes.root ||
        location.pathname.startsWith("/games") ||
        location.pathname.startsWith("/favorites") ||
        location.pathname.startsWith("/offers") ||
        location.pathname.startsWith("/live-casino") ||
        location.pathname.startsWith("/promotions")
    );
};
